module.exports = __webpack_public_path__ + "static/img/indice.77e9d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indice.png
// module id = 74IR
// module chunks = 1